// extracted by mini-css-extract-plugin
export default {"modal":"DoubleConfirmation-module__modal__CrTj0","content":"DoubleConfirmation-module__content__f2vjp","text":"DoubleConfirmation-module__text__Z2nZz"};